/**
 * Created by JackCui on 2021/12/2
 */

export default function footerSchemaHandle ({title, apiName}) {
  return {
    _type: 'footer',
    viewComponentName: 'footer',
    props: {title},
    apiName
  }
}

export const footerProps = {
  
}